import { render, staticRenderFns } from "./CashbackPurchasesWithoutPoints.vue?vue&type=template&id=bbf757be"
import script from "./CashbackPurchasesWithoutPoints.vue?vue&type=script&lang=js"
export * from "./CashbackPurchasesWithoutPoints.vue?vue&type=script&lang=js"
import style0 from "./CashbackPurchasesWithoutPoints.vue?vue&type=style&index=0&id=bbf757be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports